import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  ButtonDownloadExcel,
  ButtonsViewSelector,
} from '»components/atoms/Buttons';
import { TrlTabContainer } from '»components/molecules';
import { TabPanel } from '»components/molecules/TrlTabContainer';

import { getIsLoading, getWebAreas } from '../marketStockExchange.seletors';
import {
  TabButtonsContainer,
  WrapperStyled,
} from './TrlStockExchangeMarketTabs.styles';

const a11yProps = (index) => {
  return {
    id: `issue-tab-${index}`,
    'aria-controls': `issue-tabpanel-${index}`,
  };
};

export const TrlStockExchangeMarketTabs = ({
  children,
  currentTab,
  setCurrentTab,
  tabButtons,
  downloadExcelButtonClick,
  isDownloadExcelButtonDisabled,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const webAreas = useSelector(getWebAreas);
  const isLoading = useSelector(getIsLoading);

  const getTabs = () => {
    const tabs = webAreas?.map((area) => ({
      label: area.descr,
      disabled: !!isLoading,
      ...a11yProps(area.id),
    }));

    return tabs;
  };

  return (
    <WrapperStyled>
      <TrlTabContainer
        value={currentTab}
        handleChange={setCurrentTab}
        tabs={getTabs()}
        mainTabContainer
      >
        <TabButtonsContainer hide={!tabButtons || tabButtons.length === 0}>
          {tabButtons?.map((button) => {
            if (button === 'viewSelector')
              return <ButtonsViewSelector key={button} />;

            if (!isMobile)
              return (
                <ButtonDownloadExcel
                  key={button}
                  handleExportExcel={downloadExcelButtonClick}
                  isDisabled={isDownloadExcelButtonDisabled}
                />
              );

            return null;
          })}
        </TabButtonsContainer>
      </TrlTabContainer>
      {webAreas?.map((area, index) => {
        return (
          <TabPanel key={area.id} value={currentTab} index={index}>
            {children}
          </TabPanel>
        );
      })}
    </WrapperStyled>
  );
};

TrlStockExchangeMarketTabs.propTypes = {
  children: PropTypes.element.isRequired,
  currentTab: PropTypes.number.isRequired,
  setCurrentTab: PropTypes.func.isRequired,
  tabButtons: PropTypes.arrayOf(
    PropTypes.oneOf(['viewSelector', 'downloadExcel']),
  ),
  downloadExcelButtonClick: PropTypes.func,
  isDownloadExcelButtonDisabled: PropTypes.bool,
};
